import { FocusEstateNewsAPIBody, FocusEstateNewsInstance, isFocusEstateNewsWithPic } from '../../models/apis/focusAPI';
// import { useAPI } from './useAPI';
import { useAPIWithJsonp } from './useAPI.jsonp';

const initData: FocusEstateNewsAPIBody = {
    code: 200,
    message: '',
    data: {
        list: [],
    },
};

const returnCity: { cip: string, cid: string, cname: string } = { cip: '', cid: '', cname: '' };

export const useFocusAPI = (adPos: number, indexes: number[]): FocusEstateNewsInstance[] => {
    const cid = returnCity.cid || '';
    const [res] = useAPIWithJsonp<FocusEstateNewsAPIBody>(`//adv-sv-show.focus.cn/be_fox_say3?cityCode=${cid}&adposId=${adPos}&_=${+ new Date()}`, initData, []);
    const articles:FocusEstateNewsInstance[] = [];
    indexes.forEach(e => {
        const data = res.data.list[e];
        if ( !data) { return; }
        const resData:FocusEstateNewsInstance = {
            link: data.link,
            content: {
                title: '',
            },
        };
        if (isFocusEstateNewsWithPic(data)) {
            resData.content = {
                title: data.resource_map.pic_text.despriction,
                picUrl: data.resource_map.pic_text.url,
            };
        } else {
            resData.content = {
                title: data.resource_map.text.despriction,
            };
        }
        articles.push(resData);
    });
    return articles;
};



// WEBPACK FOOTER //
// ./src/hooks/APIs/useFocusAPI.ts